import api from "../api";

export const submitApplication = async (data: unknown[]) => {
  return api.post(`/Employee/CompletePortfolio`, data);
};
